setTimeout(() => {
    document.querySelectorAll('.SearchableInput').forEach((input) => {
        new SearchableInput(input);
    });
}, 0);


class SearchableInput {
    constructor(wrapper) {
        this.minLen = 3;
        this.wrapper = wrapper;
        this.url = this.wrapper.dataset.url;
        this.input = wrapper.querySelector('input');
        this.dropdown = wrapper.querySelector('.SearchableInput__dropdown');
        this.wrapper.addEventListener('click', this.handleClick.bind(this));
        this.inputDebounce = debounce(this.handleInput.bind(this), 250);
        this.input.addEventListener('input', () => {
            this.input.dataset.value = '';
            this.dropdown.innerHTML = ``;
            this.wrapper.classList.add('SearchableInput--loading');
            this.inputDebounce();
            this.open();
        });
        this.wrapper.querySelector('.SearchableInput__clean').addEventListener('click', this.clean.bind(this));
        this.dropdown.addEventListener('click', this.clickList.bind(this));
    }

    clickList(e) {
        let target = e.target;
        if (!target.closest('a')) {
            e.preventDefault();
            e.stopPropagation();
            if (target.tagName === 'SPAN') {
                target = target.parentElement;
            }
            if (target.dataset.type === 'region') {
                citySet(this.getTextItem(target), target.dataset.value);
                goToSearch();
                this.close();
            } else if ('value' in target.dataset) {
                this.input.dataset.href = target.getAttribute('href') || '';
                this.input.dataset.value = target.dataset.value;
                this.input.dataset.group = target.dataset.parent;
                this.input.dataset.groupTitle = target.dataset.parentTitle;
                this.input.value = this.getTextItem(target);
                this.close();
                const event = new CustomEvent('select', { detail: target });
                this.wrapper.dispatchEvent(event);
                this.input.dispatchEvent(new Event('change'));
            }
        }
    }

    getTextItem(el) {
        return [...el.childNodes].reduce((name, node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                return name + node.data;
            }
            return name;
        }, '');
    }

    checkValue() {
        return this.input.value.length >= this.minLen;
    }

    handleClick() {
        if (!this.wrapper.classList.contains('SearchableInput--active')) {
            this.open();
        }
    }

    open() {
        const className = 'SearchableInput--active';
        const active = this.checkValue();
        const isClassActive = this.wrapper.classList.contains(className);
        if (active && !isClassActive) {
            this.wrapper.classList.add(className);
            ClickOutside.addListener(this.wrapper, () => this.close());
            if(this.input.value) {
                this.handleInput();
            }
        }
        if (!active && isClassActive) {
            this.close();
        }
    }

    close() {
        this.wrapper.classList.remove('SearchableInput--active');
        ClickOutside.removeListener(this.wrapper);
    }

    handleInput() {
        this.dropdown.innerHTML = ``;
        if (this.input.value.length >= this.minLen) {
            fetch(`${this.url}?q=${this.input.value}`).then((d) => d.json()).then((list) => {
                this.dropdown.innerHTML = list.map((el) => SearchableInput.getItem(el)).join('\n');
            }).finally(() => {
                this.wrapper.classList.remove('SearchableInput--loading');
            })
        }
    }

    static getItem({ title, value, group, groupId, icon, list, link, type }, parent = null) {
        if (group) {
            let html = `<div data-group="${groupId}" style="--icon: url(${icon});">${group}</div>`;
            if (list) {
                html += list.map((item) => SearchableInput.getItem(item, { groupId, group })).join('\n');
            }
            return html;
        }
        let tag = link ? 'a' : 'div';
        let subTitle = '';
        if (type) {
            tag = 'div';
        }
        if (type === 'link') {
            subTitle = `<a target="_blank" class="subtitle" href="${link}">Посмотреть ЖК</a>`;
        }
        return `<${tag} ${value ? `data-value="${value}"` : ''} data-type="${type}" ${link && `href="${link}" target="_blank"`} ${parent !== null && `data-parent=${parent.groupId} data-parent-title=${parent.group}`}>${title}${subTitle}</${tag}>`;
    }

    clean() {
        this.input.value = '';
        this.handleInput();
        this.close();
    }
}

